import React from 'react'

import CreditPaymentProfile from '../components/credit-payment/profile'

import {
	_getCheckQbToken, 
	_postQbCode, 
	_getQbInitialiseSelections,
} from '../services'
 
class CreditPaymentProfilePage extends React.Component{

	constructor(props){
		super(props);

		this.state = {
			qbAccessToken:true,
			gdAccessToken:true
		}

		let qbCode = new URLSearchParams(this.props.location.search).get('code')

		_getCheckQbToken()
		.then( res => {
			// console.log(res)
			if(res.data.accessToken){
				this.setState({qbAccessToken: true})
			} else {
				this.setState({qbAccessToken:false})
				if(qbCode){
					_postQbCode(qbCode)
					.then(res => {
						if(res.data.success){
							this.setState({qbAccessToken:true})
							_getQbInitialiseSelections()
						}
					})
				}
			}
		})
	}

	render(){

		const { paymentId } = this.props.match.params

		return (
			<div style={{ margin: 16 }}>
				<CreditPaymentProfile 
					paymentId={paymentId}
				/>
			</div>
		)
	}

}

export default CreditPaymentProfilePage;


// WEBPACK FOOTER //
// ./src/containers/credit-payment-profile-page.js